<template>
  <div class="join-container">
    <h1>
      <span v-text="invitation.company_name" /> vous invite à rejoindre sa campagne Yuzu.
    </h1>
    <p v-if="!invitation.has_account">
      Pour rejoindre l’organisation et accéder à la plateforme, veuillez remplir
      les informations ci-jointes
    </p>
    <div class="invitation-infos">
      <img
        class="picture"
        :src="getInviterImage(invitation.inviter)"
        alt="picture"
      />
      <div class="sender">
        <span>Invité à rejoindre l’organisation par</span>
        <p
          v-text="
            `${invitation.inviter?.first_name} ${invitation.inviter?.last_name}`
          "
        />
      </div>
    </div>
    <Button
      v-if="invitation.has_account"
      class="primary"
      label="Rejoindre l'organisation"
      @click="join"
    />
  </div>
</template>

<script setup>
import { getRandomUserPicture, getImage } from "@/composables/getImage.js";
import { useUserStore } from "@/stores/user.js";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";

const userStore = useUserStore();

const route = useRoute();

const router = useRouter();

const toast = useToast();

defineProps({
  invitation: {
    type: Object,
    required: true,
  },
});

function getInviterImage(inviter) {
  if (!inviter) return;

  if (inviter.image_id) {
    return getImage(inviter.image_id);
  } else {
    return getRandomUserPicture(inviter.first_name);
  }
}

async function join() {
  const resp = await userStore.joinNewCompany(route.query.invitation_id);

  if (resp.key) {
    toast.error(getError(resp.key));
    return;
  }

  if (userStore.auth_token) {
    await userStore.getUser("/login", resp.member.company_id);

    router.push({
      name: "home",
      params: { companyId: resp.member.company_id },
    });
  } else {
    window.location.replace("/login");
  }
}
</script>
